export default "__VITE_ASSET__DcdDKq4f__"